import { inject, Injectable } from '@angular/core';
import { CurrentSubscriptionService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { FeatureFlags, FeatureFlagService } from '@rma/dashboard/generic/util/feature-flags';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PauseSubscriptionService {
  private readonly currentSubscriptionService = inject(CurrentSubscriptionService);
  private readonly featureService = inject(FeatureFlagService);

  private readonly displayPauseSubscription$ = this.featureService.getFeature$(FeatureFlags.DisplayPauseSubscription, false);
  private readonly isMonthlySubscription$ = this.currentSubscriptionService.currentSubscriptionSummary$.pipe(
    map((summary) => summary?.isMonthly ?? false),
  );

  public showPauseSubscription$: Observable<boolean> = combineLatest([
    this.displayPauseSubscription$,
    this.currentSubscriptionService.currentSubscription$,
    this.isMonthlySubscription$,
  ]).pipe(
    map(
      ([displayPause, subscription, isMonthly]) =>
        displayPause && isMonthly && !subscription.isFree && !subscription.hasCancelled && !subscription.onTrial,
    ),
  );
}
